import { date } from 'quasar'
const { utcToZonedTime } = require('date-fns-tz')
import store from '@/store/index'

export const getRelativeDate = (val, lowercase, isUTC) => {
  if (isUTC) {
    val = utcToZonedTime(val, store.getters.getUserTimeZone)
  }
  let daysAgo = date.getDateDiff(new Date(), val, 'days')
  if (daysAgo < 2) {
    return setCase(daysAgo === 0 ? 'Today' : 'Yesterday')
  }
  if (daysAgo < 11) {
    return `${daysAgo} days ago`
  }
  return date.formatDate(val, "ddd Do MMMM 'YY") // e.g. "Wed 1st July '20"

  function setCase(text) {
    if (lowercase) {
      return text.toLowerCase()
    }
    return text
  }
}

export const getRelativeDateTime = (val, lowercase, isUTC) => {
  if (isUTC) {
    val = utcToZonedTime(val, store.getters.getUserTimeZone)
  }
  let minutesAgo = date.getDateDiff(new Date(), val, 'minutes')
  if (minutesAgo < 60) {
    return `${minutesAgo} minutes ago`
  }
  let hoursAgo = date.getDateDiff(new Date(), val, 'hours')
  if (hoursAgo < 24) {
    return `${hoursAgo} hours ago`
  }
  let daysAgo = date.getDateDiff(new Date(), val, 'days')
  if (daysAgo < 2) {
    return setCase(daysAgo === 0 ? 'Today' : 'Yesterday')
  }
  if (daysAgo < 11) {
    return `${daysAgo} days ago`
  }
  let dateText = date.formatDate(val, "ddd Do MMMM 'YY") // e.g. "Wed 1st July '20"
  let timeText = date.formatDate(val, 'h:mm A') // e.g. "04:33 AM"

  return dateText + ' at ' + timeText
  function setCase(text) {
    if (lowercase) {
      return text.toLowerCase()
    }
    return text
  }
}

export const getFormattedDateTime = (val, isUTC) => {
  if (isUTC) {
    val = utcToZonedTime(val, store.getters.getUserTimeZone)
  }
  let dateText = date.formatDate(val, "ddd Do MMMM 'YY") // e.g. "Wed 1st July '20"
  let timeText = date.formatDate(val, 'h:mm A') // e.g. "04:33 AM"

  return dateText + ' at ' + timeText
}

export const convertMinutes = min => {
  if (!min) return
  const d = Math.floor(min / 1440)
  const h = Math.floor((min - d * 1440) / 60)
  const m = Math.round(min % 60)

  if (d > 0) {
    return `${d}d ${h}h ${m}m`
  } else {
    return `${h}h ${m}m`
  }
}
